import { create } from 'zustand';

export type SessionStatus = 'loading' | 'authenticated' | 'unauthenticated';

interface SessionState {
  userId: string | null;
  status: SessionStatus;
  /** Set by the AuthProvider from auth-state changes. `null` = signed out. */
  setUser: (userId: string | null) => void;
}

/**
 * Holds only the auth identity (user id + status). Tokens are managed by the
 * Supabase SDK, never copied here (instructions/06_SECURITY.md).
 */
export const useSessionStore = create<SessionState>((set) => ({
  userId: null,
  status: 'loading',
  setUser: (userId) => set({ userId, status: userId ? 'authenticated' : 'unauthenticated' }),
}));
